import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ALERT_ERROR_NAME } from './alert-error-name';
import { AlertErrorDataService } from './alert-error-data.service';
import { NgClass } from '@angular/common';
import { AlertErrorMessage } from './alert-error-message';
import { I18NService } from '../../core/i18n/i18n.service';

@Component({
    selector: 'adminui-alert-error',
    imports: [NgClass],
    templateUrl: './alert-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertErrorComponent implements OnInit {

  readonly alertErrorName = input.required<string>();

  readonly errorCode = signal('');
  readonly show = signal(false);
  readonly alertErrorMessage = signal<AlertErrorMessage>(new AlertErrorMessage());

  readonly maximumMessagesDisplayedWithoutScroll = 5;
  readonly alertErrorNameConst = ALERT_ERROR_NAME;
  readonly alertErrorMessageType = AlertErrorMessage.TYPE;

  private readonly alertErrorDataService = inject(AlertErrorDataService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly i18n = inject(I18NService);

  /**
   * The heading and the close button's name, from the locale files - they were hardcoded English.
   * The fallbacks matter here more than anywhere: a boot failure raises this before translations load.
   */
  get title(): string {
    return this.i18n.messages['common']?.['alertTitleError'] ?? 'Error';
  }

  get closeLabel(): string {
    return this.i18n.messages['common']?.['ariaLabelClose'] ?? 'Close';
  }

  ngOnInit(): void {
    this.alertErrorDataService.alertErrorName = this.alertErrorName();

    this.alertErrorDataService.alertMessage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(alertErrorMessage => {
        if (alertErrorMessage.alertErrorName === this.alertErrorName()) {
          this.alertErrorMessage.set(alertErrorMessage);
          this.errorCode.set(alertErrorMessage.errorCode);
          this.show.set(true);
        }
      });
  }

  close(): void {
    this.show.set(false);
  }
}
